import useGetWhiteLabelLogo from "@/features/white-label-logo/useGetWhiteLabelLogo";
import { useLoaderData } from "@tanstack/react-router";

export default function EmailVerifying() {
	const { logo } = useLoaderData({ from: "__root__" });
	const { data: logoSrc } = useGetWhiteLabelLogo({ logoPath: logo });

	return (
		<div className="w-screen h-screen flex flex-col items-center justify-center text-center transition-opacity duration-300 gap-3">
			<div className="pb-10 flex justify-center">
				<div className="relative">
					<div className="p-10 rounded-full w-[150px] h-[150px] z-20 relative flex items-center justify-center">
						<img
							src={logoSrc}
							alt="Brand Logo"
							className="block w-16 h-16 object-contain"
						/>
					</div>
					<div className="p-12 bg-primary-400 rounded-full w-[180px] h-[180px] absolute animate-pulseCustom -top-[16px] -left-[14px] z-10"></div>
				</div>
			</div>
			<div>
				<h2 className="text-2xl font-bold text-textDark">Verifying...</h2>
			</div>
			<div className="text-sm font-medium text-textDark">
				Please wait while we verify your email address.
			</div>
		</div>
	);
}
